import React from 'react';

const BootstrapCol = ({ width = 12, style, children }) =>
{
	return (
		<div className={'col-md-' + width } style={style}>
			{ children }
		</div>
	)
}

export default BootstrapCol ;


